import React, { useState, useEffect, useCallback, useRef } from "react";
import infoIcon from "../../../../../assets/images/Icons/info_icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  matchValidateVersi,
} from "../../../../../helpers/global_helper";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import BetSuccessPopup from "../../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import { formatPricewithdecimal, formatPrice } from "../../../../NumberFormat";
import { setCommonConfig } from "../../../../../redux/actions";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance } from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup"
import MarketClose from "../../MarketClose"
const BalakBalikVersiWap = (props) => {
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [rowsToShow, setRowsToShow] = useState(1);
  const [showTooltip, setShowTooltip] = useState(false);
  const [values, setValues] = useState([]);
  const [angakaval, setAngakaVal] = useState({});
  const [key, setKey] = useState();
  const [respData, setRespData] = useState({
    belakang: "",
    depan: "",
    tengah: "",
  });
  const [generateError, setGenerateError] = useState("");
  const [newAngakaVal, setNewAngakaVal] = useState(false);
  const [RespCalculateTotal, setRespCalculateTotal] = useState({});
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const nameRefs = useRef([]);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);

  const [ReqSubmitData, setReqSubmitData] = useState({
    dataangka: [],
    gameId: null,
    gameType: "bolak-balik",
    fastbet: true,
    action: "save",
    isfullbet: 0,
    betTogelAuth: "betTogelAuth",
    allowPartner: "allowPartner",
  });

  const [calculateTotal, setCalculateTotal] = useState({
    gameId: null,
    gameType: "bbcampuran",
    fastbet: true,
  });

  const [inputValues, setInputValues] = useState({
    "4D": "",
    "3D Belakang": "",
    "2D Belakang": "",
    "3D Depan": "",
    "2D Depan": "",
    "2D Tengah": "",
  });

  const [reqData, setReqData] = useState({
    gameId: null,
    gameType: "bbcampuran",
    fastbet: true,
    action: "save",
    betTogelAuth: "betTogelAuth",
    allowPartner: "allowPartner",
    dataangka: [],
  });

  const [angaka, setAngaka] = useState([]);

  useEffect(() => {
    dispatch(setCommonConfig({ key: "gameType", value: "bolak-balik" }));
  }, []);

  const handleTebakInputChange = useCallback((e, rowIndex) => {
    const { name, value } = e.target;
    if (value.length > 4 || value.length < 2 || !/^[0-9]*$/.test(value)) {
      setErrorMessage(props.t("guess_filled_24_digit"));
      setShowErrorPopup(true);
      setValues("");
      return;
    } else {
      const newValue = [...values];
      newValue[rowIndex] = value;
      setValues(newValue);
    }
  });
  const handleTebakInputChangeMobile = useCallback((e) => {
    const { name, value } = e.target;
    if (value.length > 4 || value.length < 2 || !/^[0-9]*$/.test(value)) {
      setErrorMessage(props.t("guess_filled_24_digit"));
      setShowErrorPopup(true);
      setValues("");
      return;
    } else {
      setValues(value);
    }
  });

  const handleChange = (e, rowIndex, type) => {
    const { name, value } = e.target;
    if (/^[0-9]*$/.test(value)) {
      if (type === "nomor") {
        const newValue = [...values];
        newValue[rowIndex] = value;
        setValues(newValue);
      } else {
        setInputValues((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        setAngakaVal((prevState) => ({
          ...prevState,
          [name]: type + "-" + values,
        }));
        setKey(name);
      }
    }
  };

  useEffect(() => {
    if (
      Object.keys(angakaval).length != undefined &&
      Object.keys(angakaval).length > 0
    ) {
      setNewAngakaVal(true);
      setAngaka([]);
      const newVal = Object.entries(angakaval).map((item) => {
        setAngakaVal((prevState) => ({
          ...prevState,
          [item[1].split("-")[0]]: item[1].split("-")[0] + "-" + values,
        }));
      });
    }
  }, [values]);

  const handleChangeMobile = (e, type) => {
    const { name, value } = e.target;

    if (/^[0-9]*$/.test(value)) {
      if (type === "nomor") {
        // const newValue = [...values];
        // newValue[0] = value;
        // setValues(newValue);
        setValues([value]);
      } else {
        setInputValues((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        setAngakaVal((prevState) => ({
          ...prevState,
          [name]: type + "-" + value,
        }));
        setKey(name);
      }
    }
  };

  const GenerateHandleChange = (e, type) => {
    const { name, value } = e.target;
    if (type == "belakang") {
      setCalculateTotal((prevReqData) => ({
        ...prevReqData,
        databet_belakang: value,
      }));
      setRespData((prevData) => ({
        ...prevData,
        belakang: value,
      }));
    }
    if (type == "depan") {
      setCalculateTotal((prevReqData) => ({
        ...prevReqData,
        databet_depan: value,
      }));
      setRespData((prevData) => ({
        ...prevData,
        depan: value,
      }));
    }
    if (type == "tengah") {
      setCalculateTotal((prevReqData) => ({
        ...prevReqData,
        databet_tengah: value,
      }));
      setRespData((prevData) => ({
        ...prevData,
        tengah: value,
      }));
    }
  };

  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };

  const clearBetValue = (rowIndex, name) => {
    setInputValues((prevState) => ({
      ...prevState,
      [name]: "",
    }));

    if (nameRefs.current[rowIndex]) {
      nameRefs.current[rowIndex].value = "";
    }
  };

  const validateInputs = () => {
    if (device !== "Desktop") {
      if (values && values.length === 2) {
        if (
          !inputValues["2D Belakang"] &&
          !inputValues["2D Depan"] &&
          !inputValues["2D Tengah"]
        ) {
          setErrorMessage(props.t("fill_2d_back_front_middle"));
          setShowErrorPopup(true);
          return false;
        }
      } else if (values && values.length === 3) {
        if (!inputValues["3D Belakang"] && !inputValues["3D Depan"]) {
          setErrorMessage(props.t("fill_3d_back_front"));
          setShowErrorPopup(true);
          return false;
        }
      }
    } else {
      for (let i = 0; i < values.length; i++) {
        const nomor = values[i];
        if (nomor && nomor.length === 2) {
          if (
            !inputValues["2D Belakang"] &&
            !inputValues["2D Depan"] &&
            !inputValues["2D Tengah"]
          ) {
            setErrorMessage(props.t("fill_2d_back_front_middle"));
            setShowErrorPopup(true);
            return false;
          }
        } else if (nomor && nomor.length === 3) {
          if (!inputValues["3D Belakang"] && !inputValues["3D Depan"]) {
            setErrorMessage(props.t("fill_3d_back_front"));
            setShowErrorPopup(true);
            return false;
          }
        }
      }
    }
    return true;
  };

  const generateProcess = () => {
    if (!validateInputs()) {
      return;
    }
    const isValidData = reqData.dataangka.some(
      (item) => item && item[1] !== ""
    );
    const isValidDataLen = reqData.dataangka.every((item, index) => {
      let splitName = item[0].split("-");
      let name = splitName[0];
      let minValue = "";
      let maxValue = "";

      if (name == "4D") {
        minValue = betDiscount.showMin4d / 1000;
        maxValue = betDiscount.showMax4d / 1000;
      } else if (name == "3D Belakang") {
        minValue = betDiscount.showMin3dBelakang / 1000;
        maxValue = betDiscount.showMax3dBelakang / 1000;
      } else if (name == "2D Belakang") {
        minValue = betDiscount.showMin2dBelakang / 1000;
        maxValue = betDiscount.showMax2dBelakang / 1000;
      } else if (name == "3D Depan") {
        minValue = betDiscount.showMin3dDepan / 1000;
        maxValue = betDiscount.showMax3dDepan / 1000;
      } else if (name == "2D Depan") {
        minValue = betDiscount.showMin2dDepan / 1000;
        maxValue = betDiscount.showMax2dDepan / 1000;
      } else if (name == "2D Tengah") {
        minValue = betDiscount.showMin2dTengah / 1000;
        maxValue = betDiscount.showMax2dTengah / 1000;
      }
      let amount =
        item[1] === 0 ? item[1] : item[1] == "" ? "error" : item[1] / 1000;
      if (amount >= 0 || amount !== "error") {
        if (amount < minValue) {
          showMessage(`Minimum bet for ${name} is 1`, "error", "error");
          setGenerateError(name);
          clearBetValue(0, name);
          return false;
        } else if (amount > maxValue) {
          showMessage(
            props.t("you_have_reached_max_bet_value"),
            "error",
            "error"
          );
          return false;
        }
      }
      return true;
    });
    if (isValidData) {
      if (!isValidDataLen) {
        return;
      }
      makeAjax(url.TOGEL_API.processBBCampuran, reqData)
        .then((response) => {
          if (response.status !== respStatus["SUCCESS"]) {
            if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }

            if (response.code !== "validation_error") {
              response.code
                ? showMessage(props.t(response.code), "error", "error")
                : showMessage(
                    props.t("guess_bet_wrong_place"),
                    "error",
                    "error"
                  );
            } else {
              showMessage("Server error: No data found", "error", "error");
            }
          } else {
            setRespData(response.data);
          }
        })
        .catch((error) => {
          showMessage(
            "Error occurred while processing: " + error.message,
            "error",
            "error"
          );
        });
    } else {
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
    }
  };

  const submitCalculateTotal = () => {
    if (
      !calculateTotal["databet_belakang"] &&
      !calculateTotal["databet_depan"] &&
      !calculateTotal["databet_tengah"]
    ) {
      showMessage(props.t("format_input"), "error", "error");
      return;
    }

    let matchValidate = matchValidateVersi("bbcampuran", calculateTotal);
    if (matchValidate) {
      setErrorMessage(props.t(matchValidate));
      setShowErrorPopup(true);
      return;
    }

    makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }

        if (response.code !== "validation_error") {
          response.code
            ? showMessage(props.t(response.code), "error", "error")
            : showMessage(props.t("guess_bet_wrong_place"), "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setRespCalculateTotal(response.data);
      setTotalCountClick(true);
      const newAngakas = [];
      response.data.dataangka.forEach((item) => {
        const newAngaka = [item.nomor, item.taruhan, item.status];
        newAngakas.push(newAngaka);
      });
      setReqSubmitData((prevState) => ({
        ...prevState,
        gameId: gameId,
        dataangka: newAngakas,
      }));
    });
  };

  useEffect(() => {
    allDataReset();
  }, [gameId]);

  const allDataReset = () => {
    setValues([]);
    setAngakaVal({});
    setInputValues({
      "4D": "",
      "3D Belakang": "",
      "2D Belakang": "",
      "3D Depan": "",
      "2D Depan": "",
      "2D Tengah": "",
    });
    setAngaka([]);
    setRespData([]);
    setRespCalculateTotal({});
    setCalculateTotal({
      gameId: null,
      gameType: "bbcampuran",
      fastbet: true,
    });
    setReqData({
      gameId: null,
      gameType: "bbcampuran",
      fastbet: true,
      action: "save",
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
      dataangka: [],
    });
    setReqSubmitData({
      dataangka: [],
      gameId: null,
      gameType: "bolak-balik",
      fastbet: true,
      action: "save",
      isfullbet: 0,
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
    });
    setTotalCountClick(false);
  };

  const submitProcess = (event) => {
    // if (totalCountClick) {
    //   setShowConfirmationPopup(true)
    // } else {
    if (
      !calculateTotal["databet_belakang"] &&
      !calculateTotal["databet_depan"] &&
      !calculateTotal["databet_tengah"]
    ) {
      showMessage(props.t("format_input"), "error", "error");
      return;
    }

    let matchValidate = matchValidateVersi("bbcampuran", calculateTotal);
    if (matchValidate) {
      setErrorMessage(props.t(matchValidate));
      setShowErrorPopup(true);
      return;
    }

    makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }

        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setRespCalculateTotal(response.data);
      const newAngakas = [];
      response.data.dataangka.forEach((item) => {
        const newAngaka = [item.nomor, item.taruhan, item.status];
        newAngakas.push(newAngaka);
      });
      setReqSubmitData((prevState) => ({
        ...prevState,
        gameId: gameId,
        dataangka: newAngakas,
      }));
      setShowConfirmationPopup(true);
    });
    setShowConfirmationPopup(true);

    // if (ReqSubmitData.dataangka.length > 0) {
    //   setShowConfirmationPopup(true);
    // }
    // else {
    //   setErrorMessage('Incorrect Input Format')
    //   setShowErrorPopup(true)
    // }
    // }
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.process4D3D2D, ReqSubmitData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }

        if (response.code !== "validation_error") {
          response.code
            ? setErrorMessage(props.t(response.code))
            : setErrorMessage(props.t("guess_bet_wrong_place"));
            setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      allDataReset();
      dispatch(getUserBalance());
      setSubmitRespData((prevData) => [...prevData, response.data]);
      setSuccessPopup(true);
    });
  };

  useEffect(() => {
    setCalculateTotal((prevReqData) => ({
      ...prevReqData,
      gameId: gameId,
      databet_belakang: respData.belakang,
      databet_depan: respData.depan,
      databet_tengah: respData.tengah,
    }));
  }, [respData, inputValues, angakaval, reqData]);

  useEffect(() => {
    let updatedAngaka = [];
    if (generateError) {
      updatedAngaka = angaka.map((value) => {
        if (value[0] === angakaval[generateError]) {
          return [angakaval[generateError], "", null];
        }
        return value;
      });
      setAngaka(updatedAngaka);

      // Update reqData
      setReqData((prevReqData) => ({
        ...prevReqData,
        gameId: gameId,
        dataangka: updatedAngaka,
      }));
      setGenerateError("");
    } else if (newAngakaVal) {
      // Create newAngakas if inputValues[key] is an empty string
      const newAngakas = [];
      Object.keys(inputValues).forEach((key) => {
        newAngakas.push([
          key + "-" + values,
          inputValues[key] == "" ? "" : inputValues[key] * 1000,
          inputValues[key] == 0 || "" ? null : "success",
        ]);
      });
      setAngaka(newAngakas);
      // // Update reqData
      setReqData((prevReqData) => ({
        ...prevReqData,
        gameId: gameId,
        dataangka: newAngakas,
      }));
      setNewAngakaVal(false);
    } else {
      if (angakaval[key] !== undefined && inputValues[key] !== undefined) {
        let found = false;
        updatedAngaka = angaka.map((value) => {
          if (value.includes(angakaval[key])) {
            found = true;
            return [
              angakaval[key],
              inputValues[key] == "" ? "" : inputValues[key] * 1000,
              inputValues[key] == 0 || "" ? null : "success",
            ];
          }
          return value;
        });

        // Create newAngakas if inputValues[key] is an empty string
        const newAngakas = [];
        Object.keys(inputValues).forEach((key) => {
          if (inputValues[key] === "") {
            const newAngaka = [key + "-" + values, "", null];
            if (
              !updatedAngaka.some(
                (angakaItem) => angakaItem[0] === newAngaka[0]
              )
            ) {
              newAngakas.push(newAngaka);
            }
          }
        });
        if (!found) {
          updatedAngaka.push([
            angakaval[key],
            inputValues[key] * 1000,
            inputValues[key] == 0 || "" ? null : "success",
          ]);
        }
        if (newAngakas.length > 0) {
          updatedAngaka = [...updatedAngaka, ...newAngakas];
        }
      }
      setAngaka(updatedAngaka);
      setReqData((prevReqData) => ({
        ...prevReqData,
        gameId: gameId,
        dataangka: updatedAngaka,
      }));
    }
  }, [inputValues, angakaval, key, generateError]);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };
  const handleConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  const handlePopupClose = () => {
    setSubmitRespData([]);
    setSuccessPopup(false);
  };
  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="bolakbalik_versiwap_container">
            {device === "Desktop" ? (
              <div className="versicontainer_new">
                <table>
                  <thead>
                    <tr className="Heading">
                      <th>{props.t("number")}</th>
                      <th>{props.t("4D")}</th>
                      <th>{props.t("3D Belakang")}</th>
                      <th>{props.t("2D Belakang")}</th>
                      <th>{props.t("3D Depan")}</th>
                      <th>{props.t("2D Depan")}</th>
                      <th>{props.t("2D Tengah")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(rowsToShow)].map((_, index) => (
                      <tr key={index}>
                        <td className="inputs">
                          <input
                            type="text"
                            name="nomor"
                            maxlength="4"
                            value={values[index] || ""}
                            onBlur={handleTebakInputChange}
                            onChange={(e) => handleChange(e, index, "nomor")}
                          />
                        </td>
                        <td className="inputs">
                          <input
                            ref={(el) => (nameRefs.current[index] = el)}
                            type="text"
                            name="4D"
                            value={inputValues["4D"]}
                            onChange={(e) => handleChange(e, index, "4D")}
                            placeholder="1 = 1,000 IDR"
                          />
                        </td>
                        <td className="inputs">
                          <input
                            ref={(el) => (nameRefs.current[index] = el)}
                            type="text"
                            name="3D Belakang"
                            value={inputValues["3D Belakang"]}
                            onChange={(e) =>
                              handleChange(e, index, "3D Belakang")
                            }
                            placeholder="1 = 1,000 IDR"
                          />
                        </td>
                        <td className="inputs">
                          <input
                            ref={(el) => (nameRefs.current[index] = el)}
                            type="text"
                            name="2D Belakang"
                            value={inputValues["2D Belakang"]}
                            onChange={(e) =>
                              handleChange(e, index, "2D Belakang")
                            }
                            placeholder="1 = 1,000 IDR"
                          />
                        </td>
                        <td className="inputs">
                          <input
                            ref={(el) => (nameRefs.current[index] = el)}
                            type="text"
                            name="3D Depan"
                            value={inputValues["3D Depan"]}
                            onChange={(e) => handleChange(e, index, "3D Depan")}
                            placeholder="1 = 1,000 IDR"
                          />
                        </td>
                        <td className="inputs">
                          <input
                            ref={(el) => (nameRefs.current[index] = el)}
                            type="text"
                            name="2D Depan"
                            value={inputValues["2D Depan"]}
                            onChange={(e) => handleChange(e, index, "2D Depan")}
                            placeholder="1 = 1,000 IDR"
                          />
                        </td>
                        <td className="inputs">
                          <input
                            ref={(el) => (nameRefs.current[index] = el)}
                            type="text"
                            name="2D Tengah"
                            value={inputValues["2D Tengah"]}
                            onChange={(e) =>
                              handleChange(e, index, "2D Tengah")
                            }
                            placeholder="1 = 1,000 IDR"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="bolak_balik_table_container">
                <div className="bb_table_item">
                  <p>{props.t("number")}</p>
                  <input
                    type="text"
                    name="nomor"
                    maxlength="4"
                    value={values}
                    onBlur={handleTebakInputChangeMobile}
                    onChange={(e) => handleChangeMobile(e, "nomor")}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div>
                <div className="bb_table_item">
                  <p>{props.t("4D")}</p>
                  <input
                    type="text"
                    name="4D"
                    value={inputValues["4D"]}
                    onChange={(e) => handleChange(e, null, "4D")}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div>
                <div className="bb_table_item">
                  <p>{props.t("3D Belakang")}</p>
                  <input
                    type="text"
                    name="3D Belakang"
                    value={inputValues["3D Belakang"]}
                    onChange={(e) => handleChange(e, null, "3D Belakang")}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div>
                <div className="bb_table_item">
                  <p>{props.t("2D Belakang")}</p>
                  <input
                    type="text"
                    name="2D Belakang"
                    value={inputValues["2D Belakang"]}
                    onChange={(e) => handleChange(e, null, "2D Belakang")}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div>
                <div className="bb_table_item">
                  <p>{props.t("3D Depan")}</p>
                  <input
                    type="text"
                    name="3D Depan"
                    value={inputValues["3D Depan"]}
                    onChange={(e) => handleChange(e, null, "3D Depan")}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div>
                <div className="bb_table_item">
                  <p>{props.t("2D Depan")}</p>
                  <input
                    type="text"
                    name="2D Depan"
                    value={inputValues["2D Depan"]}
                    onChange={(e) => handleChange(e, null, "2D Depan")}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div>
                <div className="bb_table_item">
                  <p>{props.t("2D Tengah")}</p>
                  <input
                    type="text"
                    name="2D Tengah"
                    value={inputValues["2D Tengah"]}
                    onChange={(e) => handleChange(e, null, "2D Tengah")}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                </div>
              </div>
            )}
            <div className="btnGenerate">
              <button onClick={generateProcess}>Generate</button>
            </div>
          </div>
          <div className="versicontainer_new">
            <p>4D 3D dan 2D (Belakang)</p>
            <textarea
              rows="7"
              value={respData.belakang || ""}
              onChange={(e) => GenerateHandleChange(e, "belakang")}
              placeholder="123*1234*12#5+11*222*333#1+33*777#2"
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>Depan</p>
            <textarea
              rows="7"
              value={respData.depan || ""}
              onChange={(e) => GenerateHandleChange(e, "depan")}
              placeholder="123*12#5+11*222*333#1+33*777#2"
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>Tengah</p>
            <textarea
              rows="7"
              value={respData.tengah || ""}
              onChange={(e) => GenerateHandleChange(e, "tengah")}
              placeholder="12#5+11#1+33#2"
              pattern="[0-9+\-*/#]*"
            ></textarea>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total {props.t("line")}</span> :{" "}
                  {RespCalculateTotal.line ? RespCalculateTotal.line : "-"}
                </p>
                <p>
                  <span>Total {props.t("purchases")}</span> :{" "}
                  {RespCalculateTotal.tover
                    ? formatPrice(RespCalculateTotal.tover)
                    : "-"}{" "}
                  &nbsp;
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>Total {props.t("discount")}</span>:{" "}
                  {RespCalculateTotal.disc
                    ? formatPrice(RespCalculateTotal.disc)
                    : "-"}
                </p>
                <p>
                  <span>Total {props.t("payment")}</span> :{" "}
                  {RespCalculateTotal.pay
                    ? formatPrice(RespCalculateTotal.pay)
                    : "-"}
                </p>
              </div>
              <div className="info_icon">
                <img src={infoIcon} alt="" onClick={toggleTooltip} />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format {props.t("bet")}
                      </span>
                      <span className="tooltip_content">
                        {" "}
                        123*1234*12#5000+11*222*333#1000+33*777#2000
                      </span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                {props.t("converter")}
                <br /> 1 = 1,000
              </p>
            </div>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={submitCalculateTotal}>
                  {props.t("count_total")}
                </button>
              </div>
              <div className="button_right">
                <button onClick={allDataReset} className="reset">
                  {props.t("Reset")}
                </button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              <button onClick={submitProcess} className="submit">
                {props.t("submit")}
              </button>
            </div>
            {showConfirmationPopup && (
              <ConfirmBetDeskonPopup
                onClose={handleConfirmationPopupClose}
                submitProcessOk={submitProcessOk}
              />
            )}
            {showCancelledPopup && (
              <CancelledBetDeskonPopup
                onClose={() => setShowCanclledPopup(false)}
              />
            )}
            {successPopup && (
              <div className="popup-overlay ">
                <BetSuccessPopup
                  response={SubmitRespData}
                  onClose={handlePopupClose}
                />
                {/* onClose={() => setSuccessPopup(false)} */}
              </div>
            )}
            {
              /*---error popup --*/
              showErrorPopup && (
                <ErrorInnerPopup
                  modalTitle={""}
                  modalHeader={true}
                  onCloseModal={() => setShowErrorPopup(false)}
                >
                  <ErrorPopup
                    message={errMessage}
                    onClose={() => setShowErrorPopup(false)}
                  />
                </ErrorInnerPopup>
              )
            }
          </div>
        </>
      )}
    </div>
  );
};

export default withTranslation()(BalakBalikVersiWap);
